import React, {Fragment, useState, useEffect} from "react";
import styled from "styled-components";
import tw from "twin.macro";
import { css } from "styled-components/macro"; //eslint-disable-line
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import Hero from "components/hero/TwoColumnWithVideo.js";
import Features from "components/features/ThreeColSimple.js";
import MainFeature from "components/features/TwoColWithButton.js";
import MainFeature2 from "components/features/TwoColSingleFeatureWithStats2.js";
import TabGrid from "components/cards/TabCardGrid.js";
import Testimonial from "components/testimonials/ThreeColumnWithProfileImage.js";
import DownloadApp from "components/cta/DownloadApp.js";
import Footer from "components/footers/FiveColumnWithInputForm.js";
import ReactModalAdapter from "helpers/ReactModalAdapter.js";

import { useSnackbar } from "react-simple-snackbar";
import CountUp from 'react-countup';
import { useCountUp } from 'react-countup';

import { Button, Icon, Image, Modal, Table } from 'semantic-ui-react'
import { Link } from "react-router-dom"

import Form from 'components/forms/SimpleContactUs'

import chefIconImageSrc from "images/chef-icon.svg";
import celebrationIconImageSrc from "images/celebration-icon.svg";
import shopIconImageSrc from "images/shop-icon.svg";

import Iscrizione from "components/forms/TwoColContactUsWithIllustrationFullForm"
import FormLogin from 'components/forms/SimpleContactUsLogin'
import { ReactComponent as CloseIcon } from "feather-icons/dist/icons/x.svg";

export default () => {

  const Container = tw.div`relative`;
  const Subheading = tw.span`tracking-wider text-sm font-medium`;
  const HighlightedText = tw.span`bg-primary-500 text-gray-100 px-4 transform -skew-x-12 inline-block`;
  const HighlightedTextInverse = tw.span`bg-gray-100 text-primary-500 px-4 transform -skew-x-12 inline-block`;
  const Description = tw.span`inline-block mt-8`;
  const imageCss = tw`rounded-4xl`;
  const Paragraph = tw.p`my-5 lg:my-8 text-sm lg:text-base font-medium text-gray-600 max-w-lg mx-auto lg:mx-0`;

  const TwoColumn = tw.div`flex flex-col lg:flex-row md:items-center max-w-screen-xl mx-auto py-20 md:py-24`;
  const LeftColumn = tw.div`relative lg:w-6/12 lg:pr-12 flex-shrink-0 text-center lg:text-left`;
  const RightColumn = tw.div`relative mt-12 lg:mt-0 flex flex-col justify-center`;

  const Heading = tw.h1`font-black text-3xl md:text-5xl leading-snug max-w-3xl`;
  const PrimaryButton = tw.button`font-bold px-8 lg:px-10 py-3 rounded bg-primary-500 text-gray-100 hocus:bg-primary-700 focus:shadow-outline focus:outline-none transition duration-300`;
  const StyledModal = styled(ReactModalAdapter)`
  &.mainHeroModal__overlay {
    ${tw`fixed inset-0 z-50`}
  }
  &.mainHeroModal__content {
    ${tw`xl:mx-auto m-4 sm:m-16 max-w-screen-xl absolute inset-0 flex justify-center items-center rounded-lg bg-gray-200 outline-none`}
  }
  .content {
    ${tw`w-full lg:p-16`}
  }
`;
const CloseModalButton = tw.button`absolute top-0 right-0 mt-8 mr-8 hocus:text-primary-500`;

  const [open, setOpen] = React.useState(false)
  const [contatoreTotale, setContatoreTotale] = React.useState(1000)
  const [openSnackbar, closeSnackbar] = useSnackbar();
  const [modalIsOpenLogin, setModalIsOpenLogin] = useState(false);
  const [apriModaleLista, setApriModaleLista] = useState(false);
  const [arrayLista, setArrayLista] = useState([]);
  const [oggi, setOggi] = useState(new Date());
  const [giorno, setGiorno] = useState(new Date());

  const toggleModalLogin = () => setModalIsOpenLogin(!modalIsOpenLogin);

  const { countUp, start, pauseResume, reset, update } = useCountUp({
    start: 0,
    end: 100,
    duration: 5
  });

  var today = new Date();
  var dd = String(today.getDate()).padStart(2, '0');
  var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
  var yyyy = today.getFullYear();

  today = dd + '/' + mm + '/' + yyyy;


  useEffect(() => {

    let formData = new FormData();

    formData.append('data', today); 

    const requestOptions = {
      method: 'POST',
      body: formData
      //Essendo creato con FormData non devo specificare headers
    };

    fetch('https://recode.digital/corona-anti-virus/index.php/api/conta_ore_guardia/', requestOptions)
            .then(response => response.text())
            .then(risp => {

              update(parseInt(risp))
            });

    fetch('https://recode.digital/corona-anti-virus/index.php/api/conta_ore_guardia_totale/', requestOptions)
            .then(response => response.text())
            .then(risp => {

              setContatoreTotale(parseInt(risp))
            });

    fetch('https://recode.digital/corona-anti-virus/index.php/api/info_ore_guardia_giornaliere/', requestOptions)
            .then(response => response.json())
            .then(risp => {

              setArrayLista(risp);
              
            });

  },[])

  const aggiornaTabella = () => {

    let formData = new FormData();

    let giornotemp = giorno;
    let _dd = String(giornotemp.getDate()).padStart(2, '0');
    let _mm = String(giornotemp.getMonth() + 1).padStart(2, '0'); //January is 0!
    let _yyyy = giornotemp.getFullYear();

    giornotemp = _dd + '/' + _mm + '/' + _yyyy;

    formData.append('data', giornotemp); 

    const requestOptions = {
      method: 'POST',
      body: formData
      //Essendo creato con FormData non devo specificare headers
    };

    fetch('https://recode.digital/corona-anti-virus/index.php/api/info_ore_guardia_da_giorno/', requestOptions)
    .then(response => response.json())
    .then(risp => {
      setArrayLista(risp);
      
    });

  }


  

  const stampaOggi = () => {
    var today = new Date();
    var dd = String(today.getDate()).padStart(2, '0');
    var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!

    return  dd + '/' + mm;
  }

  const stampaGiorno = (giornata) => {
    var dd = String(giornata.getDate()).padStart(2, '0');
    var mm = String(giornata.getMonth() + 1).padStart(2, '0'); //January is 0!

    return  dd + '/' + mm;
  }

  const stampaLista = arrayLista.map( elemento => 
    <li>● {elemento.nome} - {elemento.citta}</li>
  )

  function stampaFascia (idFascia)  {
    let stringa= "";
    arrayLista.filter(elemento => elemento.fascia === idFascia).map(elemento => stringa = stringa+elemento.nome+" ("+elemento.citta+"), ");
    return <span>{stringa}</span>;
  }

  

  return (
    <Fragment>
    <AnimationRevealPage>

    {/* <Link to="/en">
      <Button circular style={{position: "fixed", bottom: "20px", right: "20px", zIndex: "9"}} >English</Button>
    </Link> */}

    <Button circular icon="arrow up" onClick={()=>{window.scrollTo(0,0)}} style={{position: "fixed", bottom: "60px", right: "20px", zIndex: "9"}} />

    <StyledModal
      closeTimeoutMS={300}
      className="mainHeroModal"
      isOpen={modalIsOpenLogin}
      onRequestClose={toggleModalLogin}
      shouldCloseOnOverlayClick={true}
    >
      <CloseModalButton onClick={toggleModalLogin}>
        <CloseIcon tw="w-6 h-6" />
      </CloseModalButton>
      <div className="content">
        <FormLogin toggleModalLogin={toggleModalLogin} update={update}/>
      </div>
    </StyledModal>
    
    <Modal
      open={apriModaleLista}
      onClose={() => setApriModaleLista(false)}
      onOpen={() => setApriModaleLista(true)}
    >
      <Modal.Header>Chi ha pregato con te oggi - {stampaOggi()}</Modal.Header>
      <Modal.Content scrolling>

        <ul>
          {stampaLista}
        </ul>
        
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={() => setApriModaleLista(false)} primary>
          Chiudi
        </Button>
      </Modal.Actions>
    </Modal>

      <Hero
        heading={<>Ora di guardia <HighlightedText>per la pace</HighlightedText> 🕊️</>}
        description={<div>"<b>Chi prega</b> tiene le proprie mani sul <b>timone della storia</b>"<br></br>San Giovanni Crisostomo</div>}
        imageSrc="https://www.recode.digital/ora-di-guardia-pace/risorse/san-michele-arcangelo.jpg"
        imageCss={imageCss}
        imageDecoratorBlob={true}
        primaryButtonText="Iscriviti ora 🙏🏻"
        loginButtonText="Login"
        primaryButtonUrl=""
        watchVideoButtonText="Meet The Chefs"
        buttonClick={toggleModalLogin}
        //loggato={loggato}
        //setLoggato = {setLoggato}
        //logout={logout}
        contatore={countUp}
      />

      <div style={{width: "100%", display: "flex", flexDirection:"column", alignItems:"center"}} id="testoiniziativa" >
        <p><b>Totale ore di guardia registrate:</b></p>
        <p style={{fontSize:"30px", marginBottom:"10px"}}><b><CountUp end={contatoreTotale} duration={5}/></b></p>
        {/* <PrimaryButton style={{marginBottom:"30px"}} onClick={()=>{setApriModaleLista(!apriModaleLista)}}>Guarda la tabella dei turni e registra la tua ora di guardia 🛡️🙏🏻</PrimaryButton> */}
        <a href="#tabella-turni"><PrimaryButton style={{marginBottom:"30px"}} >Guarda la tabella dei turni e registra la tua ora di guardia 🛡️🙏🏻</PrimaryButton></a>
        <div style={{maxWidth: "1280px"}}>
          <h1 id="spiegazione">Ora di guardia <HighlightedText>per la pace</HighlightedText> 🕊️</h1>
          <p style={{marginTop: "15px", fontSize: "14px"}}>Ho cominciato a scrivere queste poche righe ormai una decina di volte. Abbiamo una sensibilità così accesa dopo questi due anni di prova, una stanchezza così radicata, che ormai - non so se pare anche a voi - mi sembra non ci sia quasi argomento sul quale si riesca a non dividersi. Ma siccome il segno di riconoscimento che Gesù ha stabilito per i suoi è <b>l’unità</b>, vorrei scrivere il meno possibile sui fatti che stanno avvenendo intorno a noi.</p>
          <p style={{marginTop: "15px", fontSize: "17px"}}>La realtà è sempre più complessa delle tifoserie, il bene e il male davvero solo Dio li può giudicare. <b>Noi però possiamo fare qualcosa per alleviare le sofferenze</b>, le tante sofferenze sulle quali i media hanno acceso i riflettori, e anche su quelle che non si vedono, sulle guerre che ci riguardano di meno, e le tante prove che nel silenzio anche troppe famiglie normali stanno vivendo, messe alla prova da una povertà che mai avrebbero pensato di dover affrontare. Ci sono momenti in cui da qualunque parte ci giriamo, sembra esserci dolore o mancanza di speranza. Sappiamo di chi è la firma, quando pensiamo così. Non è quella di Dio. Perché non possiamo mai dimenticare che <b>c’è Dio nella trama dei nostri giorni, è lui che alla fine guiderà la storia,</b> e ogni circostanza che ci è dato di vivere - anche quella che sarebbe l’ultima che avremmo scelto - può essere trasformata in un’occasione di unione più intima con Lui.</p>
          <p style={{marginTop: "15px", fontSize: "17px"}}>Però questo non può avvenire che <b>con un combattimento</b>. Raccogliendo le tante proposte che mi sono arrivate da più parti, ho chiesto aiuto al nostro amico Emanuele Ercoli per richiamare alle armi il nostro piccolo esercito, e riorganizzare <b>la nostra ora di guardia</b>, per metterci tutti insieme, e far sì che a ogni ora del giorno e della notte ci sia almeno uno di noi che sta pregando per implorare la pace. Come un corpo solo, basterà uno di noi che stia vigilando, <b>e tutti noi saremo in preghiera</b>, in comunione, anche quando dormiremo o lavoreremo o mangeremo… </p>
          <p style={{marginTop: "15px", fontSize: "17px"}}>Preghiamo insieme <b>per chiedere la pace</b>, perché la diplomazia trovi una soluzione, <b>per tutti i luoghi del mondo in cui si sta soffrendo</b>, per la spirale di follia in cui sembriamo sul punto di precipitare, <b>per i più piccoli e poveri e indifesi</b> che stanno facendo le spese di scelte politiche e azioni militari che non vogliono il bene dell’uomo. Ricordando che<b> non ci accontentiamo di una “pace” in cui si possono uccidere i vecchi, i malati, i bambini nella pancia della mamma, o in cui si possono lasciar morire di fame le famiglie strozzate</b>. <br></br>Chiediamo che <b>venga il Suo Regno</b>, che non è certo l’assenza di azioni militari, è qualcosa di molto più grande.</p>
          <p style={{marginTop: "15px", fontSize: "17px"}}>Abbiamo pensato che in questa Quaresima, a partire dalla mezzanotte tra martedì e mercoledì delle Ceneri, <b>nell’ora di guardia ognuno può scegliere il suo modo di pregare</b>: la Via Crucis (anche la nostra!), il Rosario, il Sacro Manto a san Giuseppe, l’adorazione eucaristica, la preghiera silenziosa, la lectio divina, la liturgia delle ore, o anche la messa, magari preceduta e seguita da un momento di raccoglimento e ringraziamento, per terminare l’ora. <b>L’importante sarà l’intenzione comune.</b></p>
          <p style={{marginTop: "15px", fontSize: "17px"}}>Basterà prenotarsi anche con poco anticipo, ed <b>essere fedeli all’impegno di quell’ora</b>. Non è necessario che l’ora sia la stessa ogni giorno, e non è necessario che ognuno possa ogni giorno. L’importante è che ci sia sempre qualcuno che lo faccia, anche a nome degli altri.
          <br></br>Grazie a tutti quelli che potranno partecipare, con una o molte ore.</p>

          <div style={{width: "100%", display: "flex", flexDirection:"column", alignItems:"center", marginTop: "30px", marginBottom:"30px"}} id="tabella-turni">
            <p><b>Ore di guardia registrate il giorno {stampaOggi()}:</b></p>
            <p style={{fontSize:"30px"}}><b>{countUp}</b></p>
            <PrimaryButton onClick={()=>{toggleModalLogin()}}>Clicca qui per registrare la tua ora di guardia 🛡️✝️</PrimaryButton>
          </div>

          <div style={{width: "100%", display: "flex", flexDirection:"row", justifyContent: "space-between", alignItems: "center", marginTop: "30px", marginBottom:"30px"}} id="tabella-turni">
            <PrimaryButton onClick={()=>{setGiorno(new Date(giorno.setDate(giorno.getDate() - 1))); aggiornaTabella();}}> ⬅️ </PrimaryButton>
            <p style={{textAlign: "center"}}><b>Ore di guardia - {stampaGiorno(giorno)}:</b></p>
            <PrimaryButton onClick={()=>{setGiorno(new Date(giorno.setDate(giorno.getDate() + 1))); aggiornaTabella();}}> ➡️</PrimaryButton>
            {/* uso il new Date per dare una nuova reference allo useState giorno e farlo aggiornare */}
          </div>

          <div>
            <p style={{backgroundColor: "#6415ff", color: "white", padding: "10px", textAlign: "center", margin:"0px"}}><b>Fascia 00:00 - 01:00</b></p>
            <p style={{border: "1px solid #6415ff", padding: "10px"}}>{stampaFascia("1")}</p>
          </div>
          <div>
            <p style={{backgroundColor: "#6415ff", color: "white", padding: "10px", textAlign: "center", margin:"0px"}}><b>Fascia 01:00 - 02:00</b></p>
            <p style={{border: "1px solid #6415ff", padding: "10px"}}>{stampaFascia("2")}</p>
          </div>
          <div>
            <p style={{backgroundColor: "#6415ff", color: "white", padding: "10px", textAlign: "center", margin:"0px"}}><b>Fascia 02:00 - 03:00</b></p>
            <p style={{border: "1px solid #6415ff", padding: "10px"}}>{stampaFascia("3")}</p>
          </div>
          <div>
            <p style={{backgroundColor: "#6415ff", color: "white", padding: "10px", textAlign: "center", margin:"0px"}}><b>Fascia 03:00 - 04:00</b></p>
            <p style={{border: "1px solid #6415ff", padding: "10px"}}>{stampaFascia("4")}</p>
          </div>
          <div>
            <p style={{backgroundColor: "#6415ff", color: "white", padding: "10px", textAlign: "center", margin:"0px"}}><b>Fascia 04:00 - 05:00</b></p>
            <p style={{border: "1px solid #6415ff", padding: "10px"}}>{stampaFascia("5")}</p>
          </div>
          <div>
            <p style={{backgroundColor: "#6415ff", color: "white", padding: "10px", textAlign: "center", margin:"0px"}}><b>Fascia 05:00 - 06:00</b></p>
            <p style={{border: "1px solid #6415ff", padding: "10px"}}>{stampaFascia("6")}</p>
          </div>
          <div>
            <p style={{backgroundColor: "#6415ff", color: "white", padding: "10px", textAlign: "center", margin:"0px"}}><b>Fascia 06:00 - 07:00</b></p>
            <p style={{border: "1px solid #6415ff", padding: "10px"}}>{stampaFascia("7")}</p>
          </div>
          <div>
            <p style={{backgroundColor: "#6415ff", color: "white", padding: "10px", textAlign: "center", margin:"0px"}}><b>Fascia 07:00 - 08:00</b></p>
            <p style={{border: "1px solid #6415ff", padding: "10px"}}>{stampaFascia("8")}</p>
          </div>
          <div>
            <p style={{backgroundColor: "#6415ff", color: "white", padding: "10px", textAlign: "center", margin:"0px"}}><b>Fascia 08:00 - 09:00</b></p>
            <p style={{border: "1px solid #6415ff", padding: "10px"}}>{stampaFascia("9")}</p>
          </div>
          <div>
            <p style={{backgroundColor: "#6415ff", color: "white", padding: "10px", textAlign: "center", margin:"0px"}}><b>Fascia 09:00 - 10:00</b></p>
            <p style={{border: "1px solid #6415ff", padding: "10px"}}>{stampaFascia("10")}</p>
          </div>
          <div>
            <p style={{backgroundColor: "#6415ff", color: "white", padding: "10px", textAlign: "center", margin:"0px"}}><b>Fascia 10:00 - 11:00</b></p>
            <p style={{border: "1px solid #6415ff", padding: "10px"}}>{stampaFascia("11")}</p>
          </div>
          <div>
            <p style={{backgroundColor: "#6415ff", color: "white", padding: "10px", textAlign: "center", margin:"0px"}}><b>Fascia 11:00 - 12:00</b></p>
            <p style={{border: "1px solid #6415ff", padding: "10px"}}>{stampaFascia("12")}</p>
          </div>
          <div>
            <p style={{backgroundColor: "#6415ff", color: "white", padding: "10px", textAlign: "center", margin:"0px"}}><b>Fascia 12:00 - 13:00</b></p>
            <p style={{border: "1px solid #6415ff", padding: "10px"}}>{stampaFascia("13")}</p>
          </div>
          <div>
            <p style={{backgroundColor: "#6415ff", color: "white", padding: "10px", textAlign: "center", margin:"0px"}}><b>Fascia 13:00 - 14:00</b></p>
            <p style={{border: "1px solid #6415ff", padding: "10px"}}>{stampaFascia("14")}</p>
          </div>
          <div>
            <p style={{backgroundColor: "#6415ff", color: "white", padding: "10px", textAlign: "center", margin:"0px"}}><b>Fascia 14:00 - 15:00</b></p>
            <p style={{border: "1px solid #6415ff", padding: "10px"}}>{stampaFascia("15")}</p>
          </div>
          <div>
            <p style={{backgroundColor: "#6415ff", color: "white", padding: "10px", textAlign: "center", margin:"0px"}}><b>Fascia 15:00 - 16:00</b></p>
            <p style={{border: "1px solid #6415ff", padding: "10px"}}>{stampaFascia("16")}</p>
          </div>
          <div>
            <p style={{backgroundColor: "#6415ff", color: "white", padding: "10px", textAlign: "center", margin:"0px"}}><b>Fascia 16:00 - 17:00</b></p>
            <p style={{border: "1px solid #6415ff", padding: "10px"}}>{stampaFascia("17")}</p>
          </div>
          <div>
            <p style={{backgroundColor: "#6415ff", color: "white", padding: "10px", textAlign: "center", margin:"0px"}}><b>Fascia 17:00 - 18:00</b></p>
            <p style={{border: "1px solid #6415ff", padding: "10px"}}>{stampaFascia("18")}</p>
          </div>
          <div>
            <p style={{backgroundColor: "#6415ff", color: "white", padding: "10px", textAlign: "center", margin:"0px"}}><b>Fascia 18:00 - 19:00</b></p>
            <p style={{border: "1px solid #6415ff", padding: "10px"}}>{stampaFascia("19")}</p>
          </div>
          <div>
            <p style={{backgroundColor: "#6415ff", color: "white", padding: "10px", textAlign: "center", margin:"0px"}}><b>Fascia 19:00 - 20:00</b></p>
            <p style={{border: "1px solid #6415ff", padding: "10px"}}>{stampaFascia("20")}</p>
          </div>
          <div>
            <p style={{backgroundColor: "#6415ff", color: "white", padding: "10px", textAlign: "center", margin:"0px"}}><b>Fascia 20:00 - 21:00</b></p>
            <p style={{border: "1px solid #6415ff", padding: "10px"}}>{stampaFascia("21")}</p>
          </div>
          <div>
            <p style={{backgroundColor: "#6415ff", color: "white", padding: "10px", textAlign: "center", margin:"0px"}}><b>Fascia 21:00 - 22:00</b></p>
            <p style={{border: "1px solid #6415ff", padding: "10px"}}>{stampaFascia("22")}</p>
          </div>
          <div>
            <p style={{backgroundColor: "#6415ff", color: "white", padding: "10px", textAlign: "center", margin:"0px"}}><b>Fascia 22:00 - 23:00</b></p>
            <p style={{border: "1px solid #6415ff", padding: "10px"}}>{stampaFascia("23")}</p>
          </div>
          <div>
            <p style={{backgroundColor: "#6415ff", color: "white", padding: "10px", textAlign: "center", margin:"0px"}}><b>Fascia 23:00 - 24:00</b></p>
            <p style={{border: "1px solid #6415ff", padding: "10px"}}>{stampaFascia("24")}</p>
          </div>

          <div style={{width: "100%", display: "flex", flexDirection:"column", alignItems:"center", marginTop: "30px", marginBottom:"30px"}} id="tabella-turni">
            <PrimaryButton onClick={()=>{toggleModalLogin()}}>Clicca qui per registrare la tua ora di guardia 🛡️✝️</PrimaryButton>
          </div>


        </div>
      </div>

      </AnimationRevealPage>
      <AnimationRevealPage disabled>
      

      
      
      {/* <MainFeature
        subheading={<Subheading>Established Since 2014</Subheading>}
        heading={
          <>
            We've been serving for
            <wbr /> <HighlightedText>over 5 years.</HighlightedText>
          </>
        }
        description={
          <Description>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et
            dolore magna aliqua.
            <br />
            <br />
            Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
          </Description>
        }
        buttonRounded={false}
        textOnLeft={false}
        primaryButtonText="Latest Offers"
        imageSrc={
          "https://images.unsplash.com/photo-1460306855393-0410f61241c7?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=768&q=80"
        }
        imageCss={imageCss}
        imageDecoratorBlob={true}
        imageDecoratorBlobCss={tw`left-1/2 -translate-x-1/2 md:w-32 md:h-32 opacity-25`}
      /> */}
      {/* TabGrid Component also accepts a tabs prop to customize the tabs and its content directly. Please open the TabGrid component file to see the structure of the tabs props.*/}
      {/* <TabGrid
        heading={
          <>
            Checkout our <HighlightedText>menu.</HighlightedText>
          </>
        }
      />
      <Features
        heading={
          <>
            Amazing <HighlightedText>Services.</HighlightedText>
          </>
        }
        cards={[
          {
            imageSrc: shopIconImageSrc,
            title: "230+ Locations",
            description: "Lorem ipsum donor amet siti ceali placeholder text",
            url: "https://google.com"
          },
          {
            imageSrc: chefIconImageSrc,
            title: "Professional Chefs",
            description: "Lorem ipsum donor amet siti ceali placeholder text",
            url: "https://timerse.com"
          },
          {
            imageSrc: celebrationIconImageSrc,
            title: "Birthday Catering",
            description: "Lorem ipsum donor amet siti ceali placeholder text",
            url: "https://reddit.com"
          }
        ]}

        imageContainerCss={tw`p-2!`}
        imageCss={tw`w-20! h-20!`}
      />
      <MainFeature2
        subheading={<Subheading>A Reputed Brand</Subheading>}
        heading={<>Why <HighlightedText>Choose Us ?</HighlightedText></>}
        statistics={[
          {
            key: "Orders",
            value: "94000+",
          },
          {
            key: "Customers",
            value: "11000+"
          },
          {
            key: "Chefs",
            value: "1500+"
          }
        ]}
        primaryButtonText="Order Now"
        primaryButtonUrl="https://order.now.com"
        imageInsideDiv={false}
        imageSrc="https://images.unsplash.com/photo-1414235077428-338989a2e8c0?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEzNzI2fQ&auto=format&fit=crop&w=768&q=80"
        imageCss={Object.assign(tw`bg-cover`, imageCss)}
        imageContainerCss={tw`md:w-1/2 h-auto`}
        imageDecoratorBlob={true}
        imageDecoratorBlobCss={tw`left-1/2 md:w-32 md:h-32 -translate-x-1/2 opacity-25`}
        textOnLeft={true}
      />
      <Testimonial
        subheading=""
        heading={<>Customers <HighlightedText>Love Us.</HighlightedText></>}
      />
      <DownloadApp
        text={<>People around you are ordering delicious meals using the <HighlightedTextInverse>Treact App.</HighlightedTextInverse></>}
      /> */}
      <Footer />
    </AnimationRevealPage>
    </Fragment>
  );
}
